
import Vue from 'vue'

export default Vue.extend({
  name: 'SocialLinks',
  props: {
    color: {
      type: String,
    },
  },
  data: () => ({
    socialLinks: [
      {
        icon: '$facebook',
        href: 'https://www.facebook.com/Tech-Master-Event-104572978451011/',
      },
      {
        icon: '$instagram',
        href: 'https://www.instagram.com/techmasterevent/',
      },
      {
        icon: '$tiktok',
        href: 'https://www.tiktok.com/@techmasterevent',
      },
      {
        icon: '$pinterest',
        href: 'https://pl.pinterest.com/techmasterevent/_created/',
      },
      {
        icon: 'mdi-linkedin',
        href: 'https://www.linkedin.com/company/tech-master-event/about/'
      },
      {
        icon: 'mdi-youtube',
        href: 'https://youtube.com/@techmasterevent4377?si=sN7W7PSo3eVv7xJ3'
      }
    ],
  }),
})
